import { jsx as _jsx } from "react/jsx-runtime";
import { useState, } from 'react';
import { FieldBase } from './components/FieldBase.js';
/** Controlled textarea component
 * does not handle any other responsibilities beside displaying and controlling the field itself. */
export const Textarea = ({ className, defaultValue, id, isDisabled = false, isReadonly = false, textareaProps, textareaRef, onChange, onBlur, onFocus, placeholder, rootProps, size = 'xs', validationState = 'none', value, name, minRows = 2, resizeDirection = 'vertical', ...rest }) => {
    const [isFocused, setIsFocused] = useState(false);
    const handleBlur = (event) => {
        setIsFocused(false);
        onBlur?.(event);
    };
    const handleChange = (event) => {
        onChange?.(event.target.value, event);
    };
    const handleFocus = (event) => {
        setIsFocused(true);
        onFocus?.(event);
    };
    return (_jsx(FieldBase, { "data-test": "textarea-field", className: className, isDisabled: isDisabled, isFocused: isFocused, size: size, validationState: validationState, resizeDirection: resizeDirection, ...rootProps, ...rest, children: _jsx("textarea", { defaultValue: defaultValue, disabled: isDisabled, id: id, name: name, onBlur: handleBlur, onChange: handleChange, onFocus: handleFocus, placeholder: placeholder, readOnly: isReadonly, ref: textareaRef, value: value, rows: minRows, ...textareaProps }) }));
};
